export default __webpack_public_path__ + "static/media/coin.8d3e3931.png";